"use client"; // Ensures the component runs on the client side

import { useState } from "react";
import qualityImg from '../../assets/images/brand/branded merchandise.png';
import serviceImg from '../../assets/images/brand/corporate.png';
import valueImg from '../../assets/images/brand/business.png';
import { Link } from 'react-router-dom';

export default function TeamOne() {
  // State for dynamic content
  const [teamContent] = useState({
    tagline: "Why Choose Us",
    title: "What Sets U Brand It Apart",
    members: [
      {
        id: 1,
        name: "Premium Quality",
        role: "Guaranteed Excellence",
        image: qualityImg,
        hoverText:
          "We use only the highest quality materials and state-of-the-art printing technology. Every product is inspected to ensure it meets our exacting standards before delivery.",
        link: "/contact",
      },
      {
        id: 2,
        name: "Exceptional Service",
        role: "Personal Attention",
        image: serviceImg,
        hoverText:
          "From consultation to delivery, our dedicated team provides personalized service. We're here to guide you through every step of the branding process with expert advice.",
        link: "/contact",
      },
      {
        id: 3,
        name: "Unbeatable Value",
        role: "On Time • On Point • On Budget",
        image: valueImg,
        hoverText:
          "Competitive pricing without compromising quality. We deliver on our promises - meeting your timeline, exceeding expectations, and staying within your budget.",
        link: "/contact",
      },
    ],
  });

  return (
    <>
      {/* Team One Start */}
      <section id="th-team" className="team-one">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">{teamContent.tagline}</span>
            </div>
            <h2 className="section-title__title">
              {teamContent.title.split(" & ").map((text, index) => (
                <span key={index}>
                  {text}
                  <br />
                </span>
              ))}
            </h2>
          </div>
          <div className="row">
            {teamContent.members.map((member, index) => (
              <div
                key={member.id}
                className={`col-xl-4 col-lg-6 wow fadeIn${
                  index === 0 ? "Left" : index === 1 ? "Up" : "Right"
                }`}
                data-wow-delay={`${(index + 1) * 100}ms`}
              >
                <div className="team-one__single">
                  <div className="team-one__img-box">
                    <div className="team-one__img">
                      <img src={member.image} alt={member.name} />
                      <div className="team-one__content">
                        <h4 className="team-one__name">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title">{member.role}</p>
                      </div>
                      <div className="team-one__content-hover">
                        <h4 className="team-one__name-hover">
                          <Link to={member.link}>{member.name}</Link>
                        </h4>
                        <p className="team-one__sub-title-hover">{member.role}</p>
                        <p className="team-one__text-hover">{member.hoverText}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Team One End */}
    </>
  );
}
